import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/template/redux/actions';
import * as commonActions from '../../../features/common/redux/actions';
import * as pluginActions from '../../../features/plugin/redux/actions';
import AgreementTemplateForm from './AgreementTemplateForm';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { getTemplateFormCollectionFieldOptions } from './AgreementTemplateFormUtil';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import DocsLink from '../../../common/custom/DocsLink';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { AGREEMENT_TEMPLATE } from 'drapcode-constant';

export class AgreementTemplateEdit extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, templateId, version } = match.params;
    const args = { projectId, templateId, version };
    actions.loadProjectDetail({ projectId, version });
    actions.loadCollections({ projectId, version });
    actions.fetchTemplate(args);
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    const {
      template: { template, collections },
    } = nextProps;
    const { name: stateName } = this.state;
    if (!stateName) {
      const { content, name, subject, collectionId } = template ? template : {};
      const selectedCollection = collections.find((e) => e.collectionName === collectionId);
      const selectedCollectionFields = selectedCollection
        ? getTemplateFormCollectionFieldOptions(selectedCollection, collections)
        : [];
      if (content) {
        const blocksFromHtml = htmlToDraft(content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          name: name,
          subject: subject,
          collectionId: collectionId,
          editorState: editorState,
          selectedCollectionFields: selectedCollectionFields,
        });
      }
    }

    return true;
  };

  handleSubmit = (values) => {
    const { projectId, templateId, version } = this.props.match.params;
    let args = {
      projectId: projectId,
      templateId: templateId,
      version,
      values: values,
    };
    this.props.actions.updateTemplate(args);
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/2.0/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  render() {
    const { editorState, subject, name, collectionId, selectedCollectionFields } = this.state;
    const {
      template: { collections, updateTemplatePending, template },
      projectDetail,
      match,
      plugin,
      actions
    } = this.props;
    const { projectId, version, templateId } = match.params;
    const { installedPlugins } = plugin;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={AGREEMENT_TEMPLATE}
              title={'Agreement Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(AGREEMENT_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    {name ? (
                      <AgreementTemplateForm
                        handleSubmit={this.handleSubmit}
                        editorState={editorState}
                        name={name}
                        collectionId={collectionId}
                        subject={subject}
                        collections={collections}
                        selectedCollectionFields={selectedCollectionFields}
                        updateTemplatePending={updateTemplatePending}
                        templateId={templateId}
                        projectDetail={projectDetail}
                        projectId={projectId}
                        version={version}
                        actions={actions}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Agreement Template</b>
                </h5>
                <p>
                  You can create custom agreement templates and send them to different users. We
                  have created a step-by-step documentation that covers agreement template creation,
                  event configuration and execution.
                </p>
                <br />
                <DocsLink link="https://academy.drapcode.com/docs/app-event/event-dynamic-email-action/" />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
    projectDetail:state.common.projectDetail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementTemplateEdit);
